
export default {
  name: 'AfzalIcon'
}
